import { CaretDownFilled, FilterOutlined, SearchOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Form,
  Input,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
  Menu,
  Checkbox,
  Dropdown,
} from 'antd'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { ThemeContext } from '../../../theme/ThemeContext'
import { DateRangeFieldName, DateRangeType, DateSelect, getDateRange } from '../../../compnents/form/DateSelect'
import styles from './PrescriptionQueryList.module.css'
import { FilterColumn } from '../../../compnents/filterForm/filterForm'
import { selectInsuranceArray } from '../../../app/applicationSlice'
import { EditableRecipeCategories, getRecipeCategoryName, getRecipeStatusName, PrescriptionRecipeCategories, RecipeStatus } from '../../../models/recipe'

export const Query = (props: {
  loading?: any
  exportLoading?: any
  filterColumn?: any
  filterSelectList?: any
  submitPageList?: (v: any) => void
  onValueChange: (params: any) => void
  exportExcel: () => void
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const insuranceArray = useSelector(selectInsuranceArray)

  const [current, setCurrent] = useState<any>()

  const [head, tail] = getDateRange(DateRangeType.Today)

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname + '_yichitaizhang') || '{}'
  )

  useEffect(() => {
    if (
      Object.keys(storageParams).length
    ) {
      form.setFieldsValue({
        ...storageParams,
        timeHead: storageParams?.startDate || head,
        timeTail: storageParams?.endDate || tail,
        [DateRangeFieldName]: storageParams?._dateRange || DateRangeType.Today,
      })
    } else {
      form.setFieldsValue({
        _dateRange: 0,
        timeHead: head,
        timeTail: tail,
      })
    }
    refresh()
  }, [])

  const refresh = () => {
    props.onValueChange({
      ...storageParams,
      ...form.getFieldsValue(),
      current: current || 1,
    })
  }

  return (
    <Form
      className={styles.formStyle}
      form={form}
      onFinish={(values) => {
        const data =
          storageParams || {}
        const dataParams = {
          ...data,
          ...values,
          current: current,
        }
        props.onValueChange({
          ...dataParams,
        })
      }}
    >
      <Row style={{ marginBottom: 10 }} justify='space-between'>
        <Space>

          <Form.Item noStyle name='patientName'>
            <Input
              autoComplete='off'
              maxLength={20}
              placeholder='患者姓名'
              style={{ width: '15rem' }}
              allowClear
              onChange={() => {
                setCurrent(1)
                refresh()
              }}
            />
          </Form.Item>
          <Form.Item name='insuranceCode' noStyle>
            <Select
              placeholder='结算险种'
              style={{ width: '8.25rem' }}
              allowClear
              onChange={form.submit}
            >
              <Select.Option value={''}>全部</Select.Option>
              <Select.Option value={'ZIFEI'}>自费</Select.Option>
              {insuranceArray.map((v) => (
                <Select.Option value={v.insuranceCode} key={v.insuranceCode || v.id}>
                  {v.insuranceName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          {/* <Form.Item noStyle name="recipeCategory">
            <Select
              style={{ width: "7rem" }}
              placeholder="处方类型"
              allowClear
              onChange={form.submit}
            >
              {PrescriptionRecipeCategories?.map((v) => {
                return (
                  <Select.Option value={v} key={v}>
                    {getRecipeCategoryName(v)}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item> */}
          <Form.Item name='status' noStyle>
            <Select
              placeholder='处方状态'
              style={{ width: '8.25rem' }}
              allowClear
              onChange={form.submit}
            >
              <Select.Option value={0}>待审核</Select.Option>
              <Select.Option value={1}>审核通过</Select.Option>
              <Select.Option value={2}>审核不通过</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item noStyle name='settlementStatus'>
            <Select
              style={{ width: '9rem' }}
              placeholder='结算状态-全部'
              allowClear
              onChange={form.submit}
            >
              {[
                RecipeStatus.ToSettle,
                RecipeStatus.Settled,
                RecipeStatus.Returned,
              ].map((s) => (
                <Select.Option key={s} value={s}>
                  {getRecipeStatusName(s)}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <DateSelect
            allowClear={false}
            style={{ width: '8.5rem' }}
            labelPrefix=''
            namePrefix='time'
            placeholder='开单时间'
            initialValue={DateRangeType.Today}
            onChange={(e) => {
              if (e != 6) {
                refresh()
              }
            }}
          />
          <Button
            loading={props?.loading}
            type='primary'
            onClick={() => {
              setCurrent(1)
              refresh()
            }}
          >
            查询
          </Button>
          <FilterColumn
            filterColumn={props?.filterColumn}
            filterSelectList={props?.filterSelectList}
            // 筛选列变化时的数据
            onColumnVisibilityChange={(v: any) => {
              // 以 filterColumn 的顺序为基准，用 v 中的字段顺序重排，并保留 filterColumn 的 visible 状态
              const sortList = props?.filterColumn?.map((val: any) => {
                return {
                  ...val,
                  visible: v?.includes(val.field)
                }
              })
              props?.submitPageList && props?.submitPageList(sortList)
            }}
          />
        </Space>
        <Space>
          <Button
            loading={props?.exportLoading}
            type='primary'
            onClick={() => {
              props?.exportExcel && props?.exportExcel()
            }}
          >
            导出
          </Button>
        </Space>
      </Row>
    </Form>
  )
}

